<script>
import { PersonApi, ApiPagedFilteredRequest } from '@chirhos/chirhos-api'
import { ChiRhos } from '@paladin/core'

let ChiRhosApi = new ChiRhos().api()

var personApi = new PersonApi(ChiRhosApi)

export default {
  page() {
    return {
      title: 'People | Managed by me',
    }
  },
  components: {},
  props: {
    identity: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      profile: '',
      people: {
        active: null,
        deleted: null,
      },
      selectedPerson: null,
    }
  },
  mounted() {
    // console.log(this.user)
    this.initPeopleList()
  },
  methods: {
    initPeopleList() {
      // get people
      personApi
        .Owned({
          request: new ApiPagedFilteredRequest(null, 1, 100, true),
        })
        .then(
          (response) => {
            this.people.active = response.data.filter((obj) => !obj.isDeleted)
            this.people.deleted = response.data.filter((obj) => obj.isDeleted)
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
    },
    viewDetail(data) {
      this.selectedPerson = data
    },
  },
}
</script>

<template>
  <b-row>
    <b-col lg="7" md="7" sm="7">
      <b-card title="People I manage" class="card-profile">
        <b-tabs>
          <b-tab title="Active" active>
            <div v-if="people.active && people.active.length > 0">
              <div
                v-for="person in people.active"
                v-bind:key="person.entity.entityId"
              >
                <div>
                  <span @click="viewDetail(person.entity)">
                    {{ person.entity.firstName }} {{ person.entity.lastName }}
                  </span>
                  <RouterLink
                    :to="{
                      name: 'person',
                      params: { id: person.entity.entityId },
                    }"
                  >
                    Edit
                  </RouterLink>
                </div>
              </div>
            </div>
            <div v-else>
              You don't manage any people.
              <RouterLink :to="{ name: 'people-add' }">
                Click here
              </RouterLink>
              to add a new person.
            </div>
          </b-tab>
          <b-tab title="Deleted">
            <div v-if="people.deleted && people.deleted.length > 0">
              <div
                v-for="person in people.deleted"
                v-bind:key="person.entity.entityId"
              >
                <div>
                  <span @click="viewDetail(person.entity)">
                    {{ person.entity.firstName }} {{ person.entity.lastName }}
                  </span>
                  <RouterLink
                    :to="{
                      name: 'person',
                      params: { id: person.entity.entityId },
                    }"
                  >
                    Edit
                  </RouterLink>
                </div>
              </div>
            </div>
            <div v-else>
              You don't have any deleted users
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-col>
    <b-col lg="5" md="5" sm="5">
      <BaseCard v-if="selectedPerson" class="card-user">
        <!-- <div slot="image">
          <img src="@assets/images/background-04.jpg" alt="..." />
        </div> -->
        <div>
          <div class="author">
            <img
              :src="user.profile.picture"
              class="avatar border-white"
              alt="..."
            />
            <h4 class="title">
              {{ selectedPerson.firstName }} {{ selectedPerson.lastName }}
              <br />
              <!-- <a href="#">
                <small>@{{ selectedPerson.firstName.toLowerCase() }}</small>
              </a> -->
            </h4>
          </div>
          <div>
            <strong>Gender: </strong> {{ selectedPerson.genderType }}<br />
            <strong>Full name: </strong>{{ selectedPerson.firstName }}
            {{ selectedPerson.middleName }} {{ selectedPerson.lastName }}<br />
            <strong>Date of Birth: </strong>{{ selectedPerson.dateOfBirth
            }}<br />
            <strong>Email: </strong>{{ selectedPerson.email }}<br />
            <strong>Mobile number: </strong>{{ selectedPerson.mobilePhone }}
          </div>
        </div>
      </BaseCard>
      <b-card
        v-else
        title="Select a person to view detail"
        class="card-profile"
      />
    </b-col>
  </b-row>
</template>
